// src/layouts/UserLayout.js
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, useMediaQuery, useTheme as useMuiTheme } from '@mui/material';
import UserSidebar from '../components/user/UserSidebar';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';

const UserLayout = () => {
   const { logout, currentUser } = useAuth();
  const { theme } = useTheme();
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));

  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

  useEffect(() => {
    setSidebarOpen(!isMobile);
  }, [isMobile]);

  return (
    <Box
      data-theme={theme}
      sx={{
        display: 'flex',
        minHeight: '100vh',
        bgcolor: theme === 'dark' ? '#121212' : '#f5f7fa',
        color: theme === 'dark' ? '#f5f5f5' : '#333',
        fontFamily:
          '"Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, sans-serif',
      }}
    >
          <UserSidebar
        logout={logout}
        isOpen={sidebarOpen}
        isMobile={isMobile}
        onSidebarToggle={setSidebarOpen}
        currentUser={currentUser}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          minHeight: '100vh',
          // ✅ Match the dashboard background so there's no visible seam
          bgcolor: theme === 'dark' ? '#1a1a1a' : '#f5f7fa',
          transition: (t) =>
            t.transitions.create(['margin', 'width'], {
              easing: t.transitions.easing.sharp,
              duration: t.transitions.duration.leavingScreen,
            }),
          boxSizing: 'border-box',
          // ✅ Remove desktop padding — let each page handle its own
          // Keep only top padding on mobile for the FAB
          pt: { xs: '64px', md: 0 },
          px: 0,
          pb: 0,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default UserLayout;